<template>
  <vx-card title="Venues Location">
    <div class="mt-5">
      <GmapMap
        :center="center"
        :zoom="10"
        map-type-id="terrain"
        style="width: 100%;"
        :style="`height: ${height}`"
      >
        <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false"
        >{{infoContent}}</GmapInfoWindow>
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          @click="toggleInfoWindow(m,index)"
        />
      </GmapMap>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: "400px",
    },
    markers: {
      type: Array,
    },
  },
  data() {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      infoContent: "",
      infoOptions: {
        pixelOffset: { width: 0, height: -35 },
      },
      center: {
        lat: this.$store.state.company.latitude,
        lng: this.$store.state.company.longitude,
      },
    };
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.name;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>
